import React from 'react';
import { Link } from 'react-router-dom';
import { MoonStarIcon } from 'lucide-react';
import { business, getWhatsAppLink } from '../data/business';
export function SiteFooter() {
  const year = new Date().getFullYear();
  return <footer className="bg-emerald-900" data-id="element-89" data-mp="3mg831s5ebct1">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:px-8" data-id="element-90" data-mp="3hig2yaulkkdr">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-91" data-mp="3hhwudkqu78ce">
          <div data-id="element-92" data-mp="3dh4kcpa54zf2">
            <div className="flex items-center gap-3" data-id="element-93" data-mp="3dhmffil2h7le">
              <MoonStarIcon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-94" data-mp="38hrqvlorku3i" />
              <span className="font-display text-xl text-ivory-50" data-id="element-95" data-mp="38k4g8jwuq6ql">{business.brand}</span>
            </div>
            <p className="mt-2 text-xs uppercase tracking-[0.2em] text-sage-200" data-id="element-96" data-mp="2yjln0yjeddw0">
              {business.legalName}
            </p>
          </div>

          <nav aria-label="Secciones" data-id="element-97" data-mp="11q0mw436amlk">
            <h2 className="text-[11px] uppercase tracking-[0.2em] text-gold-300" data-id="element-98" data-mp="11oxxk0li0s7r">Secciones</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-ivory-100" data-id="element-99" data-mp="wq4g5x33ch2b">
              <li data-id="element-100" data-mp="15q27afl1uo4z">
                <a href="#sobre-nosotros" className="hover:text-gold-300" data-id="element-101" data-mp="15pk7xa33btsu">
                  Nosotros
                </a>
              </li>
              <li data-id="element-102" data-mp="vt7d28vt79wi">
                <a href="#servicios" className="hover:text-gold-300" data-id="element-103" data-mp="vtqwju13y6cn">
                  Servicios
                </a>
              </li>
              <li data-id="element-104" data-mp="10s0ozwvg6suk">
                <a href="#testimonios" className="hover:text-gold-300" data-id="element-105" data-mp="10tlkbopl6fth">
                  Testimonios
                </a>
              </li>
              <li data-id="element-106" data-mp="1tfegvgkagy7t">
                <a href="#contacto" className="hover:text-gold-300" data-id="element-107" data-mp="1tfwlp1l0okrc">
                  Contacto
                </a>
              </li>
            </ul>
          </nav>

          <nav aria-label="Información legal" data-id="element-108" data-mp="1jq4rw9kqrvnx">
            <h2 className="text-[11px] uppercase tracking-[0.2em] text-gold-300" data-id="element-109" data-mp="1joto49raqnwt">Legal</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-ivory-100" data-id="element-110" data-mp="27enuc8h41e83">
              <li data-id="element-111" data-mp="2c7z70q8lsp7x">
                <a href="#aviso-legal" className="hover:text-gold-300" data-id="element-112" data-mp="2c8id99ow5p64">
                  Aviso legal
                </a>
              </li>
              <li data-id="element-113" data-mp="2h3tgrdqehko4">
                <Link to="/terminos-y-condiciones" className="hover:text-gold-300" data-id="element-114" data-mp="2h3bdhx5bm66p">
                  Términos y Condiciones
                </Link>
              </li>
              <li data-id="element-115" data-mp="2d42jcr6dc6am">
                <Link to="/politica-de-privacidad" className="hover:text-gold-300" data-id="element-116" data-mp="283etw9xsfxii">
                  Política de Privacidad
                </Link>
              </li>
            </ul>
          </nav>

          <div data-id="element-117" data-mp="1ydlj3b5gzmfb">
            <h2 className="text-[11px] uppercase tracking-[0.2em] text-gold-300" data-id="element-118" data-mp="1yctpg5vfnyro">Contacto</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-ivory-100" data-id="element-119" data-mp="1tdqr149ykqso">
              <li data-id="element-120" data-mp="1tbw45kf4moly">
                <a href={`tel:${business.phoneHref}`} className="hover:text-gold-300" data-id="element-121" data-mp="1pcx5ghjzno2y">
                  Llamadas: {business.phone}
                </a>
              </li>
              <li data-id="element-122" data-mp="1kfn3y3jbrlyr">
                <a href={getWhatsAppLink() ?? '#contacto'} target="_blank" rel="noopener noreferrer" className="hover:text-gold-300" data-id="element-123" data-mp="1feha22dxhsnn">
                  WhatsApp: {business.whatsapp}
                </a>
              </li>
              <li data-id="element-124" data-mp="4uw2xlxnesua">
                <a href={business.mapsUrl} target="_blank" rel="noopener noreferrer" className="hover:text-gold-300" data-id="element-125" data-mp="4ucr8myld0op">
                  {business.address}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <p className="mt-10 border-t border-ivory-200/20 pt-6 text-xs leading-relaxed text-sage-100" data-id="element-126" data-mp="3daxt7jst2tib">
          © {year} {business.brand} — {business.legalName}. Servicio exclusivo
          para mayores de edad. Consultas y prácticas espirituales
          tradicionales; los resultados pueden variar y no están garantizados,
          y no sustituyen atención médica, psicológica, legal o financiera
          profesional. Consulta el{' '}
          <a href="#aviso-legal" className="text-gold-300 hover:text-gold-400" data-id="element-127" data-mp="2ahkb1wrifq7e">
            aviso legal completo
          </a>
          .
        </p>
      </div>
    </footer>;
}